<template>
  <div class="sd">
    <div class="flex p-relative" @click="set()">
      <div class="col" :style="ladrilho.floral ? 'display:block' : 'display:none'">
        <div class="contentSVG" v-html="contentSVG2" ref="svg2">
        </div>
      </div>
      <div class="col">
        <div class="contentSVG" v-html="contentSVG" ref="svg">
        </div>
      </div>
      <div :class="absToggle ? 'absText act':'absText'" v-if="ladrilho" @click="ToggleS()" >
        <p>Brasil Imperial Ladrilhos</p>
      </div>
    </div>
    <div class="overflow cores">
      <p>Cores utilizadas</p>
      <ul class="flex flex-wrap gap8">
        <li v-for="(corAc, ind) in coresUtilizadas" @click="changeColor(corAc)" :class="corAc.hex == cor.hex ? 'act' : ''">
          <span :style="'background-color:' + corAc.hex"></span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: ['ladrilho', 'cor', 'cores'],
  name: "SVGStyle",
  data() {
    return {
      contentSVG: '',
      contentSVG2: '',
      coresUtilizadas: [],
      i :0,
      absToggle:false,
      urlSvg: process.env.VUE_APP_SVG,
    }
  },
  mounted() {
    const next = this.$refs.svg;
    next.addEventListener('click', (x) => {
      x.target.setAttribute('style', 'fill: ' + this.cor.hex + ' !important');
      localStorage.setItem(this.ladrilho.svg, this.$refs.svg.innerHTML);
      this.getCores()
    }, false);

    const next2 = this.$refs.svg2;
    next2.addEventListener('click', (x) => {
      x.target.setAttribute('style', 'fill: ' + this.cor.hex + ' !important');
      localStorage.setItem(this.ladrilho.svgFloral, this.$refs.svg2.innerHTML);
      this.$nextTick(() => {
        this.getCores();
      })
    }, false);
  },
  methods: {
    getAxios() {
      if(this.ladrilho) {
        if (!this.getLocalStorage(this.ladrilho.svg))
          axios.get(this.urlSvg + this.ladrilho.svg).then((x) => {
            this.contentSVG = x.data;
            this.$nextTick(() => {
              this.getCores();
            })
          });
        else {
          this.contentSVG = this.getLocalStorage(this.ladrilho.svg);
          this.$nextTick(() => {
            this.getCores();
          })
        }

        if (this.ladrilho.floral) if (!this.getLocalStorage(this.ladrilho.svgFloral))
          axios.get(this.urlSvg + this.ladrilho.svgFloral).then((x) => {
            this.contentSVG2 = x.data;
            this.$nextTick(() => {
            });
          });
        else this.contentSVG2 = this.getLocalStorage(this.ladrilho.svgFloral);
      } else {
        this.coresUtilizadas = '';
        this.contentSVG = '';
        this.contentSVG2 = '';
      }
    },
    ToggleS() {
      this.absToggle = this.absToggle ? false : true;
    },
    getLocalStorage(svg) {
      return localStorage.getItem(svg);
    },
    getCores() {
      let child = this.$refs.svg.innerHTML;
      let child2 = this.$refs.svg2.innerHTML;
      let regularExpression = /#(?:[0-9a-fA-F]{3}){1,2}/g // btw: this is the same as writing RegExp(/#(?:[0-9a-fA-F]{3}){1,2}/, 'g')
      let extractedHexCodes = child.match(regularExpression);
      if(this.ladrilho.floral) {
        extractedHexCodes = extractedHexCodes.concat(child2.match(regularExpression));
      }
      let arrayFinal = [];

      extractedHexCodes.forEach((x) => {
        if(!arrayFinal.includes(x)) {
          if(x != '#000000')
            arrayFinal.push(x);
        }
      });

      this.coresUtilizadas = this.cores.filter((z) => arrayFinal.includes(z.hex));
      this.$emit('corUtil', this.coresUtilizadas)
    },
    changeColor(corAct) {
      let ind = this.cores.findIndex((x)=> x.hex == corAct.hex);
      if(ind != -1)
      this.$emit('changeColor', {ind, color: corAct});;
    },
    set() {
      this.$emit('set', true);
    }
  },
  watch: {
    ladrilho() {
       this.getAxios();
    },
    cor() {
    },
    'coresUtilizadas' : {
      handler() {
        this.$emit('corUtil', this.coresUtilizadas)
      }
    }
  }
}
</script>

<style scoped>
.gap8 {
  gap: 8px;
}

</style>

<style>
.contentSVG svg {
  height: auto;
  max-width: 100%;
  width: 100%;
  cursor: alias;
}

.p-relative {
  position: relative;
}

.contentSVG svg path:hover, .contentSVG svg polygon:hover, .contentSVG svg rect:hover, .contentSVG svg circle:hover, .contentSVG svg polyline:hover, .contentSVG svg circle:hover {
  stroke: red !important;
  stroke-dasharray: 1, 1 !important;
  position: relative;
  z-index: 10;
  stroke-width: 2px;
}

.col {
  position: relative;
}

.absText {
  position: absolute;
  bottom: 8px;
  right: 1px;
  z-index: 10;
  opacity: 0.8;
  cursor: vertical-text;
}

.absText.act {
  right: inherit;
  left: 1px;
}

.absText p {
  font-size: 10px; line-height: 18px; padding: 0 12px; background: #5b6c49; color: white;
}

.contentSVG svg path, .contentSVG svg polygon, .contentSVG svg rect, .contentSVG svg rect, .contentSVG svg polyline, .contentSVG svg circle  {
  stroke: black;
  fill: white !important;
  transition: all ease-in-out 300ms;
}

.cores {
  max-height: 500px;
  overflow: auto;
  padding-right: 5px;
}

.cores {
  scrollbar-width: auto;
  scrollbar-color: #bfbfbf #ffffff
}

.cores::-webkit-scrollbar {
  width: 12px
}

.cores::-webkit-scrollbar-track {
  background: #ffffff
}

.cores::-webkit-scrollbar-thumb {
  background-color: #bfbfbf;
  border-radius: 10px;
  border: 3px solid #ffffff
}

.cores li {
  list-style: none;
  width: 54px;
  text-align: center;
  cursor: pointer;
  line-height: normal;
  font-family: Raleway,sans-serif;
  font-size: 14px;
  color: #818181;
  font-weight: 400;
}

.cores li span {
  margin-bottom: 8px;
  width: 54px;
  display: block;
  width: 54px;
  height: 54px;
  border-radius: 10px;
  box-sizing: border-box;
}

.cores li.act span {
  border: 4px solid black;
}
</style>